import React, {Component} from "react";
class AccessDeny extends Component{

    constructor(props) {
        super(props);
    }
    componentDidMount() {
    }

    render() {
        return(
            <div className={'mx-5'}>
                <div className={'div-center'}>
                    <div className={'content'}>
                        <div className={"alert alert-warning"} role="alert">Bạn chưa được cấp quyền để sử dụng chức năng này</div>
                    </div>
                </div>
            </div>
        )
    }
}
export default AccessDeny;